// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Hfk_","col":"styles_col__2-Fml"};